import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

export const customIncidentNames = new Map([
  [RugbyLeagueIncidentId.Cards, 'Cards'],
])
